<template>
	<v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript">
				<p class="steps_count">3/8</p>
				<p v-if="checkUp.smkStatType == '2'" class="steps_title_descript" >
					금연 전까지<br />
					<span class="steps_bolder_words">몇 년</span>이나 피우셨나요?
				</p>
				<p v-else class="steps_title_descript">
					현재 흡연 중이라면,<br />
					<span class="steps_bolder_words">몇 년</span>째 담배를 피우시고 계시나요?
				</p>
			</v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="center" align="center" class="pa-0 ma-0"></v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0 px-7 mt-16">
			<v-col cols="12" align-self="center" align="center" class="pa-0 slider-img">
				<span class="type-span">{{ smkTerm }}</span>
			</v-col>
			<v-col cols="12" align-self="center" align="center" class="px-auto mx-0">
				<slide-picker
					ref="picker"
					:items="items"
					:initial-index="0"
					:tab-index="1"
					suffix="년"
					@value="onValue"
				/>
			</v-col>
		</v-row>
			
        <v-container class="pa-0 ma-0 mt-7 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";
import SlidePicker from '../../components/SlidePicker';

export default {
    components: {SlidePicker},
    data: () => ({
		enableButton: true,
		smkTerm: 1, // 흡연 기간 1~99년,
        items: Array.range(1, 100)
	}),

	methods: {
		...mapActions("survey", ["setCheckupTemp", "setStep"]),

		//이전
		previous() {
			this.setStep(6)
			this.$router.push("/checkup/step6");
		},
		//다음
		next() {
			const params = {
				step: 61,
				smkTerm: this.smkTerm
			};
			this.setCheckupTemp(params);
			this.setStep(6)
			this.$router.push("/checkup/step62");
		},
        onValue ({ value }) {
		    this.smkTerm = value
		},
		async restoreData() {
            await this.$nextTick()
			if (this.checkUp.smkTerm) {
				this.smkTerm = this.checkUp.smkTerm;
				this.$refs.picker.setPosition(this.smkTerm)
			}
		}
    },
    computed: {
		...mapGetters("survey", {
			checkUp: "checkUp"
		})
	},
	mounted() {
		window.scrollTo(0, 0)
		this.setStep(6)
		this.restoreData()
	}
};
</script>

<style scoped>
    .title {
        min-height: 20vh;
    }

	.type-span {
		line-height: 5.5;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: "NanumSquare", sans-serif;
        font-weight: 700;
		font-size: 28px;
		letter-spacing: -0.36px;
		text-align: center;
		color: #ffffff;
	}

	.slider-img {
		height: 127px;
		/* width: 32vw; */
        background: url(~@/assets/images/ic-num-calendar.png) no-repeat;
        background-size: contain;
		background-position: center center;
		font-weight: bold;
		text-align: center;
		color: white;
		padding-top: 30px;
        font-size: 22px !important;
	}

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }
</style>
